module.exports = __webpack_public_path__ + "img/pr-6.8f9cf740.png";